export const INTERVAL_NAMES = {
  morning: '06:00-11:59',
  midday: '12:00-19:59',
  evening: '20:00-23:59',
  night: '00:00-05:59',
};
